import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M8 4l-4 2v5l4 2l4 -2v-5l-4 -2","key":"svg-0"}],["path",{"d":"M12 11l4 2l4 -2v-5l-4 -2l-4 2","key":"svg-1"}],["path",{"d":"M8 13v5l4 2l4 -2v-5","key":"svg-2"}]]

const IconCell = createReactComponent('outline', 'cell', 'Cell', __iconNode);

export default IconCell;